/**
 * Custom renderers for Handsontable
 *
 * These renderers are migrated from v12 and adapted for the current API
 */
import type Handsontable from 'handsontable';
import { DateUtils, DateRenderFormat } from '@/utils/Date.utils';

/**
 * InVivo date renderer
 * Renders dates in a standardized format
 *
 * @param _hot - Handsontable instance (unused but required by signature)
 * @param TD - Table cell element
 * @param _row - Row index (unused but required by signature)
 * @param _col - Column index (unused but required by signature)
 * @param _prop - Property name (unused but required by signature)
 * @param value - Cell value
 * @param _cellProperties - Cell properties (unused but required by signature)
 */
export const inVivoDateRenderer = function (
  _hot: Handsontable.Core,
  TD: HTMLTableCellElement,
  _row: number,
  _col: number,
  _prop: string | number,
  value: unknown,
  _cellProperties: Handsontable.CellProperties
): void {
  // Clear existing content
  TD.innerHTML = '';

  if (typeof value === 'string') {
    const dateContainer = document.createElement('div');
    dateContainer.textContent = DateUtils.renderDate(value, {
      format: DateRenderFormat.Date,
      defaultResponse: '',
    });
    TD.appendChild(dateContainer);
  }
};

/**
 * Renderer names for registration
 */
export const renderers = {
  inVivoDate: 'in-vivo-date',
} as const;

/**
 * Register all custom renderers for Handsontable
 *
 * @param HandsontableInstance - The Handsontable module to register renderers on
 */
export const registerCustomRenderers = (HandsontableInstance: typeof Handsontable): void => {
  HandsontableInstance.renderers.registerRenderer(renderers.inVivoDate, inVivoDateRenderer);
};
